// src/redux/slices/allPermissionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPermissions } from "@/api/new-api/permissions";

// Async thunk to fetch all permissions
export const fetchAllPermissions = createAsyncThunk(
  "permissions/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getPermissions();
      if (response.status === "success") {
        return response.data.permissions || [];
      } else {
        return rejectWithValue(
          response.message || "Failed to fetch permissions."
        );
      }
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong.");
    }
  }
);

const allPermissionSlice = createSlice({
  name: "permissions",
  initialState: {
    permissions: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetPermissions: (state) => {
      state.permissions = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.permissions = action.payload;
      })
      .addCase(fetchAllPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPermissions } = allPermissionSlice.actions;

export default allPermissionSlice.reducer;
